import endpoints from '@/utils/constants';
import { apiHelper, authHelper } from '@/utils/helpers';

const actions ={

    saveExpense(context){
        return new Promise((resolve,reject) => {
            apiHelper.call('post',`${endpoints.BASE_URL}${endpoints.API.expenses}`,context.state.expense).then((res)=>{
                if (res.status === 201)
                {
                    resolve(res.data)
                }

            }).catch(err =>{
                reject(err);
            });
        
        });
    },

    getExpenses(context){
        return new Promise((resolve,reject)=>{
            apiHelper.call('get', `${endpoints.BASE_URL}${endpoints.API.expenses}`).then((res)=>{
                if(res.status === 200) {
                    context.commit('setExpenseList', res.data);
                }
            }).catch(err =>{
                reject(err);
            })
        })
    },
    fetchExpense(context,expenseId){
        return new Promise((resolve,reject)=>{
            apiHelper.call('get',`${endpoints.BASE_URL}${endpoints.API.expenses}/${expenseId}`).then((res)=>{
                if(res.status === 200){
                    resolve(res.data)
                }
            }).catch(err =>{
                reject(err);
            })                          
        })
    },

    updateExpense(context){
          return new Promise((resolve,reject)=>{
              apiHelper.call('put', `${endpoints.BASE_URL}${endpoints.API.expenses}/${context.state.expense.expenseId}`,context.state.expense).then((res)=> {
                  if(res.status === 200)
                  {
                   context.commit('setExpense', res.data);
                   resolve(res);
                  }
              }).catch(err =>{
                  reject(err);
              })
          });
      },


     // Add Expense Type
     saveExpenseType(context){
        return new Promise((resolve,reject) => {
            apiHelper.call('post',`${endpoints.BASE_URL}${endpoints.API.expenseTypes}`,context.state.expenseType).then((res)=>{
                if (res.status === 201)
                {
                    resolve(res.data)
                }

            }).catch(err =>{
                reject(err);
            });
        
        });
    },
        getExpenseTypes(context){
            return new Promise((resolve,reject)=>{
                apiHelper.call('get', `${endpoints.BASE_URL}${endpoints.API.expenseTypes}`).then((res)=>{
                   
                    if(res.status === 200) {
                        context.commit('setExpenseTypeList', res.data);
                    }
                }).catch(err =>{
                    reject(err);
                })
            })
        },
     
        fetchExpenseType(context,expenseTypeId){
            return new Promise((resolve,reject)=>{
                apiHelper.call('get',`${endpoints.BASE_URL}${endpoints.API.expenseTypes}/${expenseTypeId}`).then((res)=>{
                    if(res.status === 200){
                        resolve(res.data)
                        }
                }).catch(err =>{
                    reject(err);
                })                          
            })
        },
        updateExpenseType(context){
            return new Promise((resolve,reject)=>{
                apiHelper.call('put', `${endpoints.BASE_URL}${endpoints.API.expenseTypes}/${context.state.expenseType.expenseTypeId}`,context.state.expenseType).then((res)=> {
                    if(res.status === 200)
                    {
                     context.commit('setExpenseType', res.data);
                     resolve(res);
                    }
                }).catch(err =>{
                    reject(err);
                })
            });
        },

        getMonthlyExpenseTotal(context, query) {
            const url = new URL(`${endpoints.BASE_URL}${endpoints.API.expenses}/month/total`);
            if(query) {
                url.search = new URLSearchParams(query);
            }
            return new Promise((resolve, reject) => {
                apiHelper.call('get',url).then(res => {
                    if(res.status === 200) {
                        context.commit('setMonthlyExpenseAmount', res.data)
                    }
                }).catch(err => {
                    reject(err)
                });
            })
        }
    
}

export default actions;